import { useIntl } from "react-intl";
import { Col, Container, Row } from "react-bootstrap";
import { handleImageLink } from "@/helpers/functions";
import styles from "../styles/style.module.scss";
// Import Components
import ContentComponent from "../ContentComponent";
import ImageContainer from "../ImageContainer";
import Emoji from "../Emoji";
// Import Images
import emojImage from "@/assets/images/emoj6.png";
import groupImage from "@/assets/images/Group.png";

const Ads5 = ({ data }) => {
  const { locale } = useIntl();
  const hrefBtn = data?.content?.items?.[0];
  return (
    <div className={`${styles["main-ourMissions"]} main-ourMissions`}>
      <Emoji src={emojImage} className="emoji emoji5" />
      <Container>
        <Row>
          <Col xs={12} md={12} lg={6} xl={6}>
            <ContentComponent data={data} hrefBtn={hrefBtn} />
          </Col>
          <Col xs={12} md={12} lg={6} xl={6}>
            <ImageContainer
              backgroundImage={groupImage}
              overlayImage={handleImageLink(data?.backgroundImage)}
              altText={data?.title?.[locale]}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Ads5;
